import { CircularProgress } from '@material-ui/core'
import axios from 'axios'
import { Link, withTranslation } from 'gatsby-plugin-react-i18next'
import { Loader } from 'google-maps'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import "./LocationSearch.css"

class LocationSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
    this.inputRef = React.createRef()
    this.attributionsRef = React.createRef()
  }
  submitSearch(e) {
    e.preventDefault()
    const search = (google) => {
      this.setState({
        loading: true
      })
      const { locations } = this.props
      if (Object.keys(locations).length > 0) {
        const { t, selectedCard } = this.props
        const input = this.inputRef.current
        const attributionsNode = this.attributionsRef.current
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': input.value}, (results, status) => {
          if (status === 'OK') {
            const firstResult = results[0]
            if (firstResult) {
              const inputLocation = firstResult.geometry.location
              const service = new google.maps.places.PlacesService(attributionsNode);
              let smallestDistance = Infinity,
                closestLocationUrl,
                counter = 0
              Object.keys(locations).forEach((locationId) => {
                const location = locations[locationId]
                const request = {
                  placeId: location.google_place_id,
                  fields: ['geometry', 'place_id']
                };
                const callback = (place, status) => {
                  if (status === google.maps.places.PlacesServiceStatus.OK) {
                    const placeLocation = place.geometry.location
                    const distance = Math.sqrt((placeLocation.lat() - inputLocation.lat())**2 + (placeLocation.lng() - inputLocation.lng())**2)
                    if (distance < smallestDistance) {
                      closestLocationUrl = location.url_name
                      smallestDistance = distance
                    }
                    counter += 1
                    if (counter === Object.keys(locations).length) {
                      window.location.href = `/location/${closestLocationUrl}${selectedCard ? `?selectedCard=${selectedCard}` : ''}`
                    }
                  }
                }
                service.getDetails(request, callback);
              })
            } else {
              input.placeholder = t(`nav:locationSearch.noResult`)
              input.classList.add('warning')
              this.setState({
                loading: false
              })
            }
          } else {
            input.placeholder = t(`nav:locationSearch.invalid`)
            input.classList.add('warning')
            this.setState({
              loading: false
            })
          }
        });
      } else {
        this.setState({
          loading: false
        })
      }
    }
    if (window.google && window.google.maps) {
      search(window.google)
    } else {
      const options = {libraries: ['places', 'geocoder']}
      const loader = new Loader(process.env.MAPS_API_KEY, options);
      loader.load().then((google) => {
        search(google)
      })
    }
  }
  render() {
    const { t, showButton, buttonText, small, nav, wrap, rounded } = this.props
    const { loading } = this.state
    return (
      <form
        className={`location-search-wrap
          ${small ? ' small' : ''}
          ${showButton ? ' show-button' : ''}
          ${wrap ? ' wrap' : ''}
          ${rounded ? ' rounded' : ''}
        `}
        onSubmit={e => this.submitSearch(e)}
      >
        <div className="attributions-node" ref={this.attributionsRef} />
        <input
          ref={this.inputRef}
          className="location-search-input"
          placeholder={nav ? t(`nav:locationSearch.placeholderNav`) : t(`nav:locationSearch.placeholder`)}
        />
        {showButton && (
          <button
            className="location-search-button submit-button"
            type="submit"
            disabled={loading}
          >
            {buttonText || t(`nav:locationSearch.button`)}
            {loading && (
              <div className="circular-progress-wrap themed">
                <CircularProgress size={16} thickness={5} />
              </div>
            )}
          </button>
        )}
      </form>
    )
  }
}
const mapStateToProps = state => ({
  locations: state.bookingsReservations.locations
})
export default connect(
  mapStateToProps,
  null
)(withTranslation(['nav'])(LocationSearch))
